<div class="layout-wrapper">

  <div class="flex flex-wrap overflow-hidden">

    <!-- HEADER -->
    <div class="w-full lg:overflow-hidden fixed z-30 bg-white">
      <sss-header>
        <sss-navbar [title]="navbar.title"
                [titleImage]="navbar.titleImage"
                [titleLink]="navbar.titleLink"
                [activeLink]="navbar.activeLink"
                [copyrightText]="navbar.copyrightText"
                [mainImage]="navbar.mainImage">
        </sss-navbar>
      </sss-header>
    </div>

    <div class="spacer-for-fixed-navbar" >&nbsp;</div>

    <!-- MAIN -->
    <div class="w-full overflow-hidden">
      <main class="m-0 -mx-4">
        <section>
          <ng-content></ng-content>
        </section>
      </main>
    </div>

    <!-- FOOTER -->
    <div class="w-full overflow-hidden">
      <sss-footer></sss-footer>
    </div>

  </div>


</div>
